module.exports = __webpack_public_path__ + "img/copy.97a06ff2.svg";